module.exports = __webpack_public_path__ + "static/media/faceMask.9b7be0f2.png";